var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMainSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.22543 9.58544C4.22543 6.61045 6.69083 4.19874 9.73206 4.19874C12.7733 4.19874 15.2387 6.61045 15.2387 9.58544C15.2387 12.5604 12.7733 14.9721 9.73206 14.9721C6.69083 14.9721 4.22543 12.5604 4.22543 9.58544ZM9.73206 3C6.01405 3 3 5.9484 3 9.58544C3 13.2225 6.01405 16.1709 9.73206 16.1709C11.2894 16.1709 12.7233 15.6536 13.8638 14.7851L15.9546 16.825C16.1942 17.0588 16.5821 17.0583 16.8211 16.8239C17.0601 16.5895 17.0596 16.21 16.82 15.9763L14.7592 13.9656C15.8197 12.8017 16.4641 11.2672 16.4641 9.58544C16.4641 5.9484 13.4501 3 9.73206 3Z",
    fill: "#9BA0AF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainSearch);
export default __webpack_public_path__ + "static/media/mainSearch.accea7d98fcee4a3bc40c8262f95c328.svg";
export { ForwardRef as ReactComponent };